import React, { CSSProperties } from 'react';
import imageSrc from 'assets/img/loader.gif';
import i18n from 'i18n';

const LOADER_SIZE = 20;

export interface ISimpleLoaderProps {
  className?: string;
  loadingText?: string;
  showLoadingText?: boolean;
  style?: CSSProperties;
  loaderSize?: number;
  spinnerFirst?: boolean;
}

const SimpleLoader: React.FunctionComponent<ISimpleLoaderProps> = ({
  className,
  loadingText,
  showLoadingText,
  style,
  loaderSize,
  spinnerFirst,
}: ISimpleLoaderProps): JSX.Element => {
  const classes = ['simple-loader', className].join(' ');

  const spinner = (
    <img
      src={imageSrc}
      alt="please wait while loading"
      height={loaderSize ? loaderSize : LOADER_SIZE}
      width={loaderSize ? loaderSize : LOADER_SIZE}
    />
  );

  const text = showLoadingText && (
    <span className={`loading-text ${spinnerFirst ? 'ml-2' : 'mr-2'}`}>{loadingText}</span>
  );

  return (
    <div className={classes} style={style}>
      {spinnerFirst ? spinner : text}
      {spinnerFirst ? text : spinner}
    </div>
  );
};

SimpleLoader.defaultProps = {
  loadingText: i18n.t('common:simpleLoader.pleaseWait'),
  showLoadingText: true,
};

export default SimpleLoader;
